export const unloadListenerFunction = (e) => {
    console.log(e, window.event);
    e = e || window.event;
    try {
        if (window.location.pathname === '/' || window.location.pathname === '/richiesta-ricevuta') {
            return '';
        }
    } catch (error) {
        console.log(error);
    }
    if (e) {
        e.returnValue = "Sicuro di volere abbondonare la pagina?";
    }

    return "Sicuro di volere abbondonare la pagina?";
};